import { useClassified } from "@/contexts/classified";
export const useSeekerReport = () => {
    var _a;
    // @ts-ignore
    const id = useClassified().id;
    // @ts-ignore
    const legacyId = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.metadata.legacyId;
    const objectType = "CLASSIFIED";
    const path = `/report?objectId=${id}&objectType=${objectType}&legacyObjectId=${legacyId}`;
    if (!id) {
        return undefined;
    }
    return path;
};
